import _regeneratorRuntime from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Copyright 2017-2021 @polkadot/api authors & contributors
// SPDX-License-Identifier: Apache-2.0


import { assert, isString, u8aToHex, u8aToU8a } from '@polkadot/util';
import { Getters } from "./Getters.mjs";
export var ApiBase =
/*#__PURE__*/
function (_Getters) {
  _inherits(ApiBase, _Getters);

  /**
   * @description Create an instance of the class
   *
   * @param options Options object to create API instance or a Provider instance
   *
   * @example
   * <BR>
   *
   * ```javascript
   * import Api from '@polkadot/api/promise';
   *
   * const api = new Api().isReady();
   *
   * api.rpc.subscribeNewHeads((header) => {
   *   console.log(`new block #${header.number.toNumber()}`);
   * });
   * ```
   */
  function ApiBase() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments.length > 1 ? arguments[1] : undefined;
    var decorateMethod = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, ApiBase);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApiBase).call(this, options, type, decorateMethod));
  }
  /**
   * @description Connect from the underlying provider, halting all network traffic
   */


  _createClass(ApiBase, [{
    key: "connect",
    value: function connect() {
      return this._rpcCore.connect();
    }
    /**
     * @description Disconnect from the underlying provider, halting all network traffic
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      return this._rpcCore.disconnect();
    }
    /**
     * @description Finds the definition for a specific [[CallFunction]] based on the index supplied
     */

  }, {
    key: "findCall",
    value: function findCall(callIndex) {
      return this.registry.findMetaCall(u8aToU8a(callIndex));
    }
    /**
     * @description Finds the definition for a specific [[RegistryError]] based on the index supplied
     */

  }, {
    key: "findError",
    value: function findError(errorIndex) {
      return this.registry.findMetaError(u8aToU8a(errorIndex));
    }
    /**
     * @description Set an external signer which will be used to sign extrinsic when account passed in is not KeyringPair
     */

  }, {
    key: "setSigner",
    value: function setSigner(signer) {
      this._rx.signer = signer;
    }
    /**
     * @description Signs a raw signer payload, string or Uint8Array
     */

  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(address, data) {
        var _ref,
            signer,
            _signer,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, signer = _ref.signer;

                if (!isString(address)) {
                  _context.next = 7;
                  break;
                }

                _signer = signer || this._rx.signer;
                assert(_signer === null || _signer === void 0 ? void 0 : _signer.signRaw, 'No signer exists with a signRaw interface. You possibly need to pass through an explicit keypair for the origin so it can be used for signing.');
                _context.next = 6;
                return _signer.signRaw(_objectSpread(_objectSpread({
                  type: 'bytes'
                }, data), {}, {
                  address: address
                }));

              case 6:
                return _context.abrupt("return", _context.sent.signature);

              case 7:
                return _context.abrupt("return", u8aToHex(address.sign(u8aToU8a(data.data))));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return ApiBase;
}(Getters);